import { render } from "./ContadorPrecio.vue?vue&type=template&id=adfe8f6e&scoped=true&ts=true"
import script from "./ContadorPrecio.vue?vue&type=script&lang=ts"
export * from "./ContadorPrecio.vue?vue&type=script&lang=ts"

import "./ContadorPrecio.vue?vue&type=style&index=0&id=adfe8f6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adfe8f6e"]])

export default __exports__